require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./group-by-in-javascript.json") })
        }
      }, "path---group-by-in-javascript");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---group-by-in-javascript!./.cache/json/group-by-in-javascript.json
// module id = 329
// module chunks = 231608221292675